export default __webpack_public_path__ + "static/media/ponentes__Africa Rubio.c020a4a2.jpg";